import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import {
  Wallet,
  Download,
  DollarSign,
  ChevronRight,
  Cpu,
  Star,
  ExternalLink,
} from "lucide-react";

const PostCompletionScreen = ({
  buyerData,
  rewardAmount,
  onViewWallet,
  onDownloadApp,
}) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center space-y-4">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
          <Wallet className="w-8 h-8 text-blue-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">
          Your Wallet is Ready
        </h1>
        <p className="text-gray-600">
          Choose your next step to access your rewards
        </p>
      </div>

      {/* Reward Summary */}
      <Card className="bg-green-50 border-green-100">
        <CardContent className="pt-6">
          <div className="flex items-start gap-3">
            <DollarSign className="w-6 h-6 text-green-500 mt-1" />
            <div>
              <p className="font-medium text-green-900">Reward Added</p>
              <p className="text-sm text-green-700">
                ${rewardAmount || buyerData?.offer?.amount.toFixed(2) || "5.00"}{" "}
                has been added to your Ownli wallet
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Options Cards */}
      <div className="grid grid-cols-1 gap-4">
        {/* Wallet Option Card */}
        <Card
          className="border-blue-100 hover:border-blue-300 hover:shadow-md transition-all cursor-pointer"
          onClick={onViewWallet}
        >
          <CardContent className="pt-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <Wallet className="w-6 h-6 text-blue-500" />
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-gray-900 mb-1">
                  View Your Wallet
                </h3>
                <p className="text-sm text-gray-600">
                  Access your rewards, track earnings, and manage your data
                  assets
                </p>
                <button className="mt-3 flex items-center gap-1 text-blue-600 text-sm">
                  Go to Wallet <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Download App Option Card */}
        <Card
          className="border-purple-100 hover:border-purple-300 hover:shadow-md transition-all cursor-pointer"
          onClick={onDownloadApp}
        >
          <CardContent className="pt-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                <Download className="w-6 h-6 text-purple-500" />
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-gray-900 mb-1">
                  Download Ownli App
                </h3>
                <p className="text-sm text-gray-600">
                  Complete more data check-ins and earn more rewards on the go
                </p>
                <button className="mt-3 flex items-center gap-1 text-purple-600 text-sm">
                  Get the App <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Future Earnings Card */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Star className="w-5 h-5 text-yellow-500" />
            Earn More with Ownli
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <Cpu className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Connect Your Vehicle
                </p>
                {/* <p className="text-xs text-gray-600">
                  Earn up to $15/month by sharing your driving data
                </p> */}
              </div>
            </div>
            {/* <div className="flex items-start gap-3">
              <Wallet className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Share Financial Data
                </p>
                <p className="text-xs text-gray-600">
                  Get paid for connecting banking and finance accounts
                </p>
              </div>
            </div> */}
            <div className="flex items-start gap-3">
              <Star className="w-5 h-5 text-blue-500 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Complete Surveys
                </p>
                <p className="text-xs text-gray-600">
                  Earn rewards by sharing your opinions and preferences
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* External View Options */}
      <div className="flex justify-between items-center">
        <button
          onClick={() =>
            window.open(
              "https://support.ownli.co/hc/en-us/articles/360011276138-Ownli-Privacy-Policy",
              "_blank"
            )
          }
          className="flex items-center gap-1 text-sm text-blue-600"
        >
          Privacy Policy
          <ExternalLink className="w-3 h-3" />
        </button>

        <button
          onClick={() => window.open("https://support.ownli.co", "_blank")}
          className="flex items-center gap-1 text-sm text-blue-600"
        >
          Support
          <ExternalLink className="w-3 h-3" />
        </button>
      </div>

      {/* Footer */}
      <p className="text-xs text-center text-gray-500">
        Thank you for using Ownli.
      </p>
    </div>
  );
};

export default PostCompletionScreen;
